type RichTextNode = {
  nodeType: string;
  data: Record<string, unknown>;
  content?: RichTextNode[];
  value?: string;
  marks?: Array<{ type: string }>;
};

const textNode = (value: string): RichTextNode => ({
  nodeType: "text",
  data: {},
  value,
  marks: [],
});

export const paragraph = (value: string): RichTextNode => ({
  nodeType: "paragraph",
  data: {},
  content: [textNode(value)],
});

export const hyperlinkParagraph = (label: string, uri: string): RichTextNode => ({
  nodeType: "paragraph",
  data: {},
  content: [
    {
      nodeType: "hyperlink",
      data: { uri },
      content: [textNode(label)],
    },
  ],
});

export const unorderedList = (items: string[]): RichTextNode => ({
  nodeType: "unordered-list",
  data: {},
  content: items.map((item) => ({
    nodeType: "list-item",
    data: {},
    content: [paragraph(item)],
  })),
});

export const richTextDocument = (...content: RichTextNode[]) => ({
  nodeType: "document",
  data: {},
  content,
});
